import { CommonModule } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule],
})
export class InfoCardComponent {
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) description!: string;
  @Input({ required: true }) index!: number;
  @Input({ required: true }) isExpanded!: boolean;
  
  toggleCard = output<number>();

  onToggle(): void {
    this.toggleCard.emit(this.index);
  }
}
